import ModalCard from "../../common/ModalCard";
import ModalActions from "../../common/ModalActions";
import Modal from "../../common/Modal";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "react-query";
import {useAppSelector} from "../../../hooks/redux";
import {fundWallet, listPaymentMethods} from "../../../shared/queries";
import SelectInput from "../../form/SelectInput";
import {formatCurrency, getPaymentMethodLabel} from "../../../shared/utils";
import {Radio, RadioGroup} from "@headlessui/react";
import {useState} from "react";
import {PaymentMethod, WalletFundParams} from "../../../types";
import toast from "react-hot-toast";
import {useHistory} from "react-router-dom";

const fundOptions = [
    { id: 1, title: formatCurrency(500), description: 'fatturazione differita', value: 500 },
    { id: 1, title: formatCurrency(1500), description: 'fatturazione differita', value: 1500 },
    { id: 2, title: formatCurrency(2000), description: 'fatturazione differita', value: 2000 },
    { id: 3, title: formatCurrency(2500), description: 'fatturazione differita', value: 2500 }
]

export default function FundWallet ({ isVisible, onCancel, onSuccess, onAddMethod } : { isVisible: boolean, onCancel: () => void, onSuccess: () => void, onAddMethod: () => void }) {

    const { t } = useTranslation()

    const [selectedCut, setSelectedCut] = useState(fundOptions[0])
    const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>()

    const currentHotelObject = useAppSelector(state => state.hotels.currentHotelObject)

    const {
        data
    } = useQuery(['paymentMethods', currentHotelObject?.idAccomodation], () => listPaymentMethods(currentHotelObject?.idAccomodation || 0), {
        enabled: (currentHotelObject !== null && currentHotelObject !== undefined)
    })

    const fundWalletMutation = useMutation((params: WalletFundParams) => fundWallet(
        params
    ), {
        onSuccess: data => {
            toast.success('Wallet ricaricato con successo')
            onSuccess()
        },
        onError: data => {
            toast.error('Impossibile ricaricare il wallet')
        }
    })

    if (!currentHotelObject || !currentHotelObject.idAccomodation) return <></>

    return (
        <>
            <Modal
                visible={isVisible}>
                <ModalCard
                    className={'w-full max-w-md'}
                    title={t('wallet.chargeWallet')}
                    actionsLoading={fundWalletMutation.isLoading}
                    renderActions={() => (
                        <ModalActions
                            onClose={onCancel}
                            isLoading={fundWalletMutation.isLoading}
                            saveLabel={t('wallet.charge')}
                            onSave={() => {
                                if (!paymentMethod || !selectedCut) return
                                fundWalletMutation.mutate({
                                    amount: selectedCut.value,
                                    idPaymentMethod: paymentMethod?.idPaymentMethod
                                })
                            }}
                        />
                    )}>

                    <div className="p-4">
                        <div className={'text-slate-600 mb-4'}>
                            {t('wallet.chargeInfo')}
                        </div>
                        <SelectInput
                            onChange={(item: any)=> {
                                console.log(item)
                                if (item) setPaymentMethod(data?.find(p => p.idPaymentMethod === item.value))
                            }}
                            options={data?.map(d => {
                                return {
                                    label: getPaymentMethodLabel(d),
                                    value: d.idPaymentMethod
                                }
                            })}
                        />
                    </div>

                    <div className={'px-4 text-orange-600'}>
                        <button onClick={onAddMethod} className={'text-left'}>Non hai ancora registrato un metodo di pagamento? Inseriscilo ora.</button>
                    </div>

                    <div className={'px-4 text-md font-semibold text-slate-700 mb-4 mt-4'}>
                        {t('wallet.fundAmount')}
                    </div>

                    <div className={'px-4 mb-6'}>
                        <fieldset aria-label="Server size">
                            <RadioGroup value={selectedCut} onChange={setSelectedCut} className="space-y-4">
                                {fundOptions.map((plan) => (
                                    <Radio
                                        key={plan.id}
                                        value={plan}
                                        aria-label={plan.title}
                                        aria-description={`${plan.description}`}
                                        className="group relative block cursor-pointer rounded-lg border border-gray-300 bg-white px-6 py-4 shadow-sm focus:outline-none data-[focus]:border-orange-600 data-[focus]:ring-2 data-[focus]:ring-orange-600 sm:flex sm:justify-between"
                                    >
                                    <span className="flex items-center">
                                      <span className="flex flex-col text-sm">
                                        <span className="font-medium text-gray-900">{plan.title}</span>
                                        <span className="text-gray-500">
                                              <span className="block sm:inline">
                                                {plan.description}
                                              </span>
                                        </span>
                                      </span>
                                    </span>
                                    <span
                                        aria-hidden="true"
                                        className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-orange-600"
                                    />
                                    </Radio>
                                ))}
                            </RadioGroup>
                        </fieldset>
                    </div>

                </ModalCard>
            </Modal>
        </>
    )

}